<script setup>
/* global axios */

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import {
  clearBrowserSessionCookies,
  clearSessionStorageOnLogout,
} from 'dashboard/store/utils/api';
import {
  clearImpersonationSession,
  useImpersonation,
} from 'dashboard/composables/useImpersonation';
import NextButton from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const { impersonation } = useImpersonation();
const now = ref(Date.now());
let timer;

const remainingMinutes = computed(() => {
  const expiresAt = new Date(impersonation.value?.expires_at || 0).getTime();
  return Math.max(0, Math.ceil((expiresAt - now.value) / 60000));
});

const endSession = async () => {
  try {
    await axios.delete('/auth/sign_out');
    clearBrowserSessionCookies();
    clearSessionStorageOnLogout();
    clearImpersonationSession();
    window.location = '/super_admin/support_impersonation_grants';
  } catch {
    useAlert(t('IMPERSONATION.END_ERROR'));
  }
};

onMounted(() => {
  timer = window.setInterval(() => {
    now.value = Date.now();
  }, 30000);
});

onBeforeUnmount(() => window.clearInterval(timer));
</script>

<template>
  <div
    class="flex items-center justify-between gap-3 px-4 py-2 text-sm bg-n-amber-3 text-n-amber-12 border-b border-n-amber-6"
  >
    <span>
      {{
        t('IMPERSONATION.ACTIVE', {
          minutes: remainingMinutes,
        })
      }}
    </span>
    <NextButton
      size="sm"
      color="slate"
      variant="faded"
      :label="t('IMPERSONATION.END')"
      @click="endSession"
    />
  </div>
</template>
